import { payloadPublisher } from '@atlassian/ufo';
import AnalyticsWebClient from '@atlassiansox/analytics-web-client';
import { version } from 'react';

import { getReleaseVersion } from '../config';

export function allowlist(_: string) {
  return true;
}

export const initUfo = (analyticsClient: AnalyticsWebClient) => {
  payloadPublisher.setup({
    product: 'uchi',
    app: {
      version: { web: getReleaseVersion() },
      framework: { name: 'react', version },
    },
    region: 'unknown',
    gasv3: analyticsClient,
    allowlist,
  });
};
